import SecureStorage from 'secure-web-storage';
import { resetStorage } from './resetStorage';

var CryptoJS = require("crypto-js");

// Use a hardcoded secret key for now
const SECRET_KEY = 'VLOMNI_SECRET_KEY';

const getSecureStorage = () => {
    return new SecureStorage(localStorage, {
        hash: function hash(key) {
            key = CryptoJS.SHA256(key, SECRET_KEY);
            return key.toString();
        },
        encrypt: function encrypt(data) {
            if (data === null || data === undefined) {
                return '';
            }
            data = CryptoJS.AES.encrypt(data, SECRET_KEY);
            return data.toString();
        },
        decrypt: function decrypt(data) {
            if (!data) {
                return '';
            }
            try {
                data = CryptoJS.AES.decrypt(data, SECRET_KEY);
                return data.toString(CryptoJS.enc.Utf8);
            } catch (error) {
                console.error('Error decrypting data:', error);
                return '';
            }
        }
    });
};

export const secureStorage_setItem = function (key, data) {
    try {
        const storage = getSecureStorage();
        if (data === null || data === undefined) {
            storage.removeItem(key);
        } else {
            storage.setItem(key, { data: data });
        }
    } catch (error) {
        console.error('Error setting secure storage item:', error);
    }
}

export const secureStorage_getItem = function (key) {
    try {
        const storage = getSecureStorage();
        let result = storage.getItem(key);
        if (result && result.data !== undefined) {
            return result.data;
        }
        return '';
    } catch (error) {
        console.error('Error getting secure storage item:', error);
        // Only reset storage if it's not an auth flow
        const urlParams = new URLSearchParams(window.location.search);
        const isAuthFlow = urlParams.get('code') !== null;
        if (!isAuthFlow) {
            resetStorage();
            window.location.replace('/');
        }
        return '';
    }
}

export const secureStorage_removeItem = function (key) {
    try {
        const storage = getSecureStorage();
        storage.removeItem(key);
    } catch (error) {
        console.error('Error removing secure storage item:', error);
    }
}

export const secureStorage_clear = function () {
    try {
        const storage = getSecureStorage();
        storage.clear();
    } catch (error) {
        console.error('Error clearing secure storage:', error);
    }
}

// Simple synchronous versions - no async needed with hardcoded key
export const secureStorage_setItemAsync = function (key, data) {
    return secureStorage_setItem(key, data);
}

export const secureStorage_getItemAsync = function (key) {
    return secureStorage_getItem(key);
}

export const secureStorage_removeItemAsync = function (key) {
    return secureStorage_removeItem(key);
}

export const secureStorage_clearAsync = function () {
    return secureStorage_clear();
}